import React from 'react';
import Resume from '../../Components/Resume/resume.js';

function ResumePage() {
  return (
      <Resume />
  )
}

export default ResumePage;